import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import React, { useContext, useMemo } from "react";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import { useTextDomainContext } from "@/app/providers";

interface MenuItemMeterProps<TRow extends object = Record<string, unknown>> {
  row?: TRow;
  menuFor?: string;
  handleClose: () => void;
  menuClick: (_action: string, _row?: TRow) => void;
  showItems?: Record<string, boolean | undefined>;
}

export const MenuItemMeter = <TRow extends object = Record<string, unknown>>(
  props: MenuItemMeterProps<TRow>,
): React.ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  const menuFor = useMemo(() => {
    return props.menuFor ?? "";
  }, [props.menuFor]);

  const handleClose = () => {
    props.handleClose();
  };

  // const handleElectricityAction = () => {
  //   props.menuClick(`${menuFor}-electricity`, props.row);
  //   handleClose();
  // };

  const handleNothingAction = () => {
    props.menuClick(`${menuFor}-nothing`, props.row);
    handleClose();
  };

  // const handleWaterAction = () => {
  //   props.menuClick(`${menuFor}-water`, props.row);
  //   handleClose();
  // };

  // const handleGasAction = () => {
  //   props.menuClick(`${menuFor}-gas`, props.row);
  //   handleClose();
  // };

  // const handleEnergyAction = () => {
  //   props.menuClick(`${menuFor}-energy`, props.row);
  //   handleClose();
  // };

  return (
    <>
      <MenuItem onClick={handleNothingAction}>
        <ListItemIcon>
          <LocalFireDepartmentIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={gettext("Nothing to show")} />
      </MenuItem>
      {/* <MenuItem onClick={handleElectricityAction}>
        <ListItemIcon>
          <BoltIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={gettext("Electricity Meters")} />
      </MenuItem>

      <MenuItem onClick={handleHeatingAction}>
        <ListItemIcon>
          <LocalFireDepartmentIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={gettext("Heating Meters")} />
      </MenuItem>

      <MenuItem onClick={handleWaterAction}>
        <ListItemIcon>
          <WaterDropIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={gettext("Water Meters")} />
      </MenuItem>

      <MenuItem onClick={handleGasAction}>
        <ListItemIcon>
          <GasMeterIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={gettext("Gas Meters")} />
      </MenuItem>

      <MenuItem onClick={handleEnergyAction}>
        <ListItemIcon>
          <AutorenewIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={gettext("Energy Meters")} />
      </MenuItem> */}
    </>
  );
};
